// extracted by mini-css-extract-plugin
module.exports = {"s1qlr1hk":"s1qlr1hk","c19yny1p":"c19yny1p"};